import React from 'react';
import { CheckCircleIcon, DocumentArrowDownIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

interface OfferSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  offerNumber: string;
  customerEmail: string;
  autoCloseDelay?: number; // in Sekunden
}

export default function OfferSuccessModal({
  isOpen,
  onClose,
  offerNumber,
  customerEmail,
  autoCloseDelay = 8
}: OfferSuccessModalProps) {
  // Auto-Close Feature entfernt

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[9999] overflow-y-auto"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }}
      aria-labelledby="modal-title" 
      role="dialog" 
      aria-modal="true"
    >
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Hintergrund-Overlay */}
        <div 
          className="fixed inset-0 transition-opacity" 
          aria-hidden="true"
          onClick={onClose}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }}
        />

        {/* Zentrierungs-Trick */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        {/* Modal Panel */}
        <div 
          className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full"
          style={{
            backgroundColor: 'white',
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            position: 'relative',
            zIndex: 1000000
          }}
        >
          {/* Header */}
          <div className="bg-green-600 px-6 py-4">
            <div className="flex items-center justify-center">
              <CheckCircleIcon className="h-8 w-8 text-white mr-3" />
              <h3 className="text-xl font-bold text-white">
                Angebot erfolgreich erstellt!
              </h3>
            </div>
          </div>
          
          {/* Content */}
          <div className="bg-white px-6 py-4">
            <div className="text-center space-y-4">
              {/* Angebotsnummer */}
              <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-lg p-4 border border-green-200">
                <p className="text-sm text-green-700 font-medium">Ihre Angebotsnummer:</p>
                <p className="text-2xl font-bold text-green-800 mt-1">{offerNumber}</p>
              </div>

              {/* Status-Informationen */}
              <div className="space-y-3">
                <div className="flex items-center justify-center text-green-600 bg-green-50 p-3 rounded-lg">
                  <DocumentArrowDownIcon className="h-5 w-5 mr-2" />
                  <span className="text-sm font-medium">PDF-Download wurde gestartet</span>
                </div>
                
                <div className="flex items-center justify-center text-green-600 bg-green-50 p-3 rounded-lg">
                  <EnvelopeIcon className="h-5 w-5 mr-2" />
                  <span className="text-sm font-medium">E-Mail wird an {customerEmail} versendet</span>
                </div>
              </div>

              {/* Zusätzliche Informationen */}
              <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                <p className="text-base font-bold text-blue-900 mb-2">Was passiert als nächstes?</p>
                <ul className="text-left space-y-2 text-sm text-blue-800">
                  <li>Sie erhalten das Angebot per E-Mail</li>
                  <li>Unser Vertriebsteam wurde benachrichtigt</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4">
            <div className="flex justify-between items-center">
              <div className="text-sm text-gray-600">
                Vielen Dank für Ihr Vertrauen!
              </div>
              <button
                type="button"
                onClick={onClose}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              >
                Schließen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 
